import * as React from 'react';
import * as firebase from 'firebase/app';
import * as Cookies from 'js-cookie';

import {Row, Col, Input, Button, Spin, message} from 'antd';
const { TextArea } = Input;

import {MessagesList} from "./MessagesList";
import {IMessage} from "./Message";

import './Chat.css'
import Constants from "../../constants";
import Firebase, {withFirebase} from "../../components/Firebase";
import {gaEnteredChat} from '../../ga/chat';

enum States {
  active,
  loading,
  noMessagesYet
}

interface IProps {
  firebase: Firebase;
  match: any;
}

interface IState {
  messages: IMessage[];
  chatState: States;
  messageInputText: string;
}

class Chat extends React.Component<IProps, IState> {

  private readonly messagesRef: React.RefObject<any>;

  private messagesCollection: firebase.firestore.CollectionReference;
  private firstMessageSnapshot: firebase.firestore.QueryDocumentSnapshot;
  private serverTimestamp: () => firebase.firestore.FieldValue;

  private isLoadingPrevMessages: boolean;
  private courseSlug: string;
  private courseName: string;

  constructor(props: IProps) {
    super(props);

    this.isLoadingPrevMessages = false;
    this.state = {
      messages: [],
      chatState: States.loading,
      messageInputText: ''
    };

    this.serverTimestamp = firebase.firestore.FieldValue.serverTimestamp;

    this.messagesRef = React.createRef();
  }

  componentDidMount() {
    this.courseSlug = this.props.match.params.courseSlug;
    this.courseName = this.courseSlug.replace(/-/g, ' ');
    gaEnteredChat(this.courseName);

    // TODO: hardcoded nu.edu.kz, should be dynamic based on user
    this.messagesCollection = this.props.firebase.firestore.collection('universities')
      .doc('nu.edu.kz')
      .collection('courses')
      .doc(this.courseSlug)
      .collection('messages');

    this.getLatestMessagesAndListen();
  }

  sendMessage = () => {
    if (this.state.messageInputText === '') {
      return;
    }

    this.messagesCollection
      .add({
        author: Cookies.get(Constants.username),
        messageText: this.state.messageInputText,
        timestamp: this.serverTimestamp()
      })
      .then((docRef) => {
        console.log("Document written with ID: ", docRef.id);
      })
      .catch((error) => {
        console.error("Error adding document: ", error);
      });

    this.clearMessageInputText();
  };

  getLatestMessagesAndListen = () => {
    this.messagesCollection
      .orderBy('timestamp', 'desc')
      .limit(20)
      .onSnapshot((snaphsot) => {

        // if there are no messages, tell user
        if (snaphsot.docs.length === 0) {
          this.setState({
            chatState: States.noMessagesYet
          });
          return;
        }

        // if we are loading messages for the first time, save pivot to first message
        // NOTE: firebase returns last message as first doc in snapshot, so first message is a last doc
        if (!this.firstMessageSnapshot) {
          this.firstMessageSnapshot = snaphsot.docs[snaphsot.docs.length - 1];
        }

        // render messages
        const newMessages: IMessage[] = [];
        snaphsot.docChanges().forEach((change) => {
          if (change.type === 'added') {
            const data = change.doc.data();
            newMessages.push({
              author: data.author,
              messageText: data.messageText,
              timestamp: data.timestamp
            });

          } else if (change.type === 'modified') {
            const data = change.doc.data();
            const msg = {
              author: data.author,
              messageText: data.messageText,
              timestamp: data.timestamp
            };

            // update modified message
            this.setState((prevState: IState) => (
              {
                messages: [...prevState.messages.slice(0, prevState.messages.length - change.newIndex - 1), msg]
              }
            ));
          }

        });

        this.appendToBottom(newMessages.reverse());
        this.scrollChatToBottom();
      })
  };

  getPreviousMessages = () => {
    if (this.isLoadingPrevMessages) {
      return;
    }
    this.isLoadingPrevMessages = true;

    if (!this.firstMessageSnapshot) {
      message.info('Loaded all messages');
      return;
    }

    this.messagesCollection
      .orderBy('timestamp', 'desc')
      .startAfter(this.firstMessageSnapshot)
      .limit(5)
      .onSnapshot((snapshot) => {
        this.firstMessageSnapshot = snapshot.docs[snapshot.docs.length - 1];
        const prevMessages = snapshot.docs.map((result) => {
          const data = result.data();
          return {
            author: data.author,
            messageText: data.messageText,
            timestamp: data.timestamp
          }
        });
        this.appendToTop(prevMessages.reverse());
        this.isLoadingPrevMessages = false;
      })
  };

  appendToTop = (prevMessages: IMessage[]) => {
    const messagesRefEl = this.messagesRef.current;

    // first lets measure how much pixels are we from bottom
    const diffFromBottom = messagesRefEl.scrollHeight - messagesRefEl.scrollTop;
    this.setState((prevState: IState) => (
      {
        messages: [...prevMessages, ...prevState.messages]
      }
    ));
    // lets jump to position where we was before adding elements to top
    messagesRefEl.scrollTop = messagesRefEl.scrollHeight - diffFromBottom;
  };

  appendToBottom = (newMessages: IMessage[]) => {
    this.setState((prevState: IState) => (
      {
        chatState: States.active,
        messages: [...prevState.messages, ...newMessages]
      }
    ));
  };

  scrollChatToBottom = () => {
    this.messagesRef.current.scrollTop = this.messagesRef.current.scrollHeight;
  };

  handleScroll = (e: any) => {
    if (e.target.scrollTop < 200) {
      this.getPreviousMessages();
    }
  };

  public render() {

    const content = ( ()=> {
      switch (this.state.chatState) {
        case States.loading:
          return <Spin size='large'/>;
        default:
          return <MessagesList messages={this.state.messages} />;
      }
    })();

    return(
      <div className='main-section'>
        <Row gutter={16}>
          <Col span={18}>

            <div className='chat' >

              <div className='content chat-header' style={{ paddingBottom: '5px' }}>
                <h3>{this.courseName}</h3>
              </div>

              <div className='content chat-messages'
                   ref={this.messagesRef}
                   style={{height: window.innerHeight * 0.7}} onScroll={this.handleScroll}>
                {content}
              </div>

              <div className='content chat-input'>
                <Row gutter={16}>
                  <Col span={23} md={20} lg={21} xl={22}>
                    <TextArea autosize={true} value={this.state.messageInputText} onChange={this.handleMessageInputTextChange}
                              style={{resize: 'none'}} />
                  </Col>
                  <Col span={1}>
                    <Button type='primary' onClick={this.sendMessage}>Send</Button>
                  </Col>
                </Row>
            </div>

            </div>
          </Col>

          <Col span={6} className='content'>
            <strong>Rules</strong> <br/>
            - No flooding <br/>
            - No personal discussions etc (for this you have whatsapp, telegram etc) <br/>
            - This chat is for course related discussions <br/>
            - Be nice and love nurate &#9786; <br/>
            - Bug reports to: <a href="https://vk.com/nurate" target='_blank'>vk.com/nurate</a>

          </Col>

        </Row>

      </div>
    )
  }

  private handleMessageInputTextChange = (e: any) => {
    this.setState({messageInputText: e.target.value});
  };

  private clearMessageInputText = () => {
    this.setState({messageInputText: ''});
  }

}

export default withFirebase(Chat);
